import { RefObject, useEffect } from 'react';

/*
 * This hooks allows us to trigger popup whenever the user is clicks/touches outside of the current component
 * but not when it is clicking on the current component (wrapperRef)
 */
const useOnClickOutside = (
  wrapperRef: RefObject<HTMLDivElement>,
  toggle = () => {},
) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as HTMLInputElement)
      ) {
        toggle();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [wrapperRef, toggle]);
};

export default useOnClickOutside;
